<template>
  <label
    class="sg-radio"
    :class="{
      [`sg-radio--${size || ''}`]: size,
      'is-disabled': disabled,
      'is-checked': modelValue === label,
    }"
    role="radio"
    :aria-checked="modelValue === label"
    :aria-disabled="disabled"
    :tabindex="tabIndex"
    @keydown.space.stop.prevent="modelValue = disabled ? modelValue : label"
    @click.prevent="changeValue"
  >
    <span
      class="sg-radio__input"
      :class="{
        'is-disabled': disabled,
        'is-checked': modelValue === label,
      }"
    >
      <input
        ref="radioRef"
        v-model="modelValue"
        class="sg-radio__original"
        :value="label"
        type="radio"
        v-bind="attrs"
        aria-hidden="true"
        :disabled="disabled"
        @focus="focus = true"
        @blur="focus = false"
        @change="handleChange"
      />
    </span>
    <span class="sg-radio__label" @keydown.stop>
      <slot>
        {{ label }}
      </slot>
    </span>
  </label>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue'
import { isPromise } from '@vue/shared'
import { isBool } from '@sgui-plus/utils/util'
import { throwError, debugWarn } from '@sgui-plus/utils/error'
import { useRadio, radioEmits, radioProps } from './radio'
export default defineComponent({
  name: 'SgRadio',
  props: radioProps,
  emits: radioEmits,

  setup(props, { emit, attrs }) {
    const { radioRef, isGroup, focus, size, disabled, tabIndex, type, modelValue, beforeChange} =
      useRadio(props, emit)
    const changeValue = () => {
      if(disabled.value) return
      if(props.label === modelValue.value) return
      if (!beforeChange) {
        modelValue.value = props.label
        handleChange()
        return
      }

      const shouldChange = beforeChange()
      const isExpectType = [isPromise(shouldChange), isBool(shouldChange)].some(
        (i) => i
      )
      if (!isExpectType) {
        throwError(
          'SgRadio',
          'beforeChange must return type `Promise<boolean>` or `boolean`'
        )
      }

      if (isPromise(shouldChange)) {
        shouldChange
          .then((result) => {
            if (result) {
              modelValue.value = props.label
              handleChange()
            }
          })
          .catch((e) => {
            debugWarn('SgRadio', `some error occurred: ${e}`)
          })
      } else if (shouldChange) {
        modelValue.value = props.label
        handleChange()
      }

    }

    function handleChange() {
      nextTick(() => emit('onChange', modelValue.value))
    }

    return {
      focus,
      isGroup,
      modelValue,
      tabIndex,
      size,
      disabled,
      radioRef,
      attrs,
      type,
      changeValue,
      handleChange,
    }
  },
})
</script>
